import { Wrapper, Content } from './StaleBetaTag.styles';

const StaleBetaTag = () => (
  <Wrapper>
    <Content>BETA</Content>
  </Wrapper>
);

export default StaleBetaTag;
